var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.478 2 19.794 15.49 31 29.75H24.75c-1.292.001-2.415-.604-3.37-1.817l-5.902-7.529-5.904 7.53c-.955 1.21-2.078 1.815-3.368 1.815H2.084c-.645-.001-1.006-.292-1.084-.873 0-.282.135-.596.406-.944l3.993-5.09 5.761-7.352L1.969 3.84c-.27-.337-.406-.653-.406-.95.001-.593.356-.89 1.065-.89H6.79c1.29 0 2.42.613 3.387 1.839l5.302 6.734 5.3-6.735c.955-1.214 2.084-1.827 3.388-1.84h6.31zM27.31 22.55l-5.538-7.035 5.54-7.036v14.07z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdc);
export default __webpack_public_path__ + "static/media/XDC.12a0c7461c6a98c13d8c69cca2996af6.svg";
export { ForwardRef as ReactComponent };